/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_Decklists_ModeInputs */



/**
* | output |
* | --- |
* | "What does Decklists Visibility control?" |
*
* @param {Og_Faq_Q_Decklists_ModeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_decklists_mode = /** @type {((inputs?: Og_Faq_Q_Decklists_ModeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_Decklists_ModeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Que contrôle la Visibilité des decks ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Qué controla la Visibilidad de decks?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O que a Visibilidade das Listas de Deck controla?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cosa controlla la Visibilità Decklist?")
	return /** @type {LocalizedString} */ ("What does Decklists Visibility control?")
});